import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { Announcement } from '../types';
import AnnouncementChip from './AnnouncementChip';
import AnnouncementFile from './AnnouncementFile';

type AnnouncementDetailsProps = {
  announcement: Announcement;
  showTargets?: boolean;
  showFiles?: boolean;
  showDescription?: boolean;
};

const AnnouncementDetails = ({
  announcement,
  showTargets = true,
  showFiles = true,
  showDescription = true,
}: AnnouncementDetailsProps) => {
  const { t } = useTranslation(TranslationsKeys.ANNOUNCEMENTS_LIST);

  return (
    <>
      <div className="w-100 d-flex flex-wrap" style={{ gap: 25 }}>
        {!!(announcement?.description?.trim() && showDescription) && (
          <section className="w-100">
            <span className="fs-16 fw-700 text-muted w-100 text-left d-flex mb-2">
              {t('table.description')}
            </span>
            <p className="w-100 text-left d-flex mb-0">
              {announcement?.description?.trim()}
            </p>
          </section>
        )}
        {!!(announcement?.targets?.length && showTargets) && (
          <section className="w-100">
            <span className="fs-16 fw-700 text-muted w-100 text-left d-flex mb-2">
              {t('table.targets')}
            </span>
            <div className="w-100 d-flex flex-wrap" style={{ gap: 5 }}>
              {announcement?.targets?.map((target) => (
                <AnnouncementChip key={target} value={target}>
                  {t(`targets.${target}`)}
                </AnnouncementChip>
              ))}
            </div>
          </section>
        )}
        {!!(announcement?.supplementaryFiles?.length && showFiles) && (
          <section className="w-100">
            <span className="fs-16 fw-700 text-muted w-100 text-left d-flex mb-2">
              {t('table.supplementaryFiles')}
            </span>
            <div className="w-100 d-flex flex-wrap" style={{ gap: 25 }}>
              {announcement?.supplementaryFiles?.map((file) => (
                <AnnouncementFile key={file.id.toString()} file={file} />
              ))}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default AnnouncementDetails;
